export const GET_FEE_TYPES = "GET_FEE_TYPES"
export const GET_FEE_TYPES_FAIL = "GET_FEE_TYPES_FAIL"
export const GET_FEE_TYPES_SUCCESS = "GET_FEE_TYPES_SUCCESS"

export const ADD_NEW_FEE_TYPE = "ADD_NEW_FEE_TYPE"
export const ADD_FEE_TYPE_SUCCESS = "ADD_FEE_TYPE_SUCCESS"
export const ADD_FEE_TYPE_FAIL = "ADD_FEE_TYPE_FAIL"

export const UPDATE_FEE_TYPE = "UPDATE_FEE_TYPE"
export const UPDATE_FEE_TYPE_SUCCESS = "UPDATE_FEE_TYPE_SUCCESS"
export const UPDATE_FEE_TYPE_FAIL = "UPDATE_FEE_TYPE_FAIL"

export const DELETE_FEE_TYPE = "DELETE_FEE_TYPE"
export const DELETE_FEE_TYPE_SUCCESS = "DELETE_FEE_TYPE_SUCCESS"
export const DELETE_FEE_TYPE_FAIL = "DELETE_FEE_TYPE_FAIL"





